import { Component, OnInit, Input, Inject, SecurityContext, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ReportPrintViewModel } from '../../model/reportPrintViewModel';
import { ReportService } from '../../api/report.service';
import { Observable } from 'rxjs';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { Utilities } from '../../../services/utilities';
import { AppTranslationService } from '../../../services/app-translation.service';
import { ActivatedRoute } from '@angular/router';
import { ScoreLevelInfo } from '../../index';
import { DomSanitizer } from '@angular/platform-browser';
import { BaseChartDirective } from 'ng2-charts';
import { ChartConfiguration, ChartType } from 'chart.js';

@Component({
    selector: 'app-report-summary2',
    templateUrl: './report-summary2.component.html',
    styleUrls: ['./report-summary2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReportSummary2Component implements OnInit {
    @ViewChild(BaseChartDirective) chart: BaseChartDirective | undefined
    reportSummary: ReportPrintViewModel;
    id: number;

    // Bar chart options
    public barChartOptions: ChartConfiguration['options'] = {
        responsive: false,
        indexAxis: 'y',
        backgroundColor: 'rgba(128,178,104,1)',
        borderColor: 'rgba(128,178,104,1)',
        layout: {
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            }
        },
        scales: {
            x:
            {
                min: 0,
                max: 100,
                beginAtZero: true,
                ticks: {
                    stepSize: 10,
                    maxTicksLimit: 10
                }
            }
        }
    };
    public barChartLabels: string[] = [];
    public barChartType: ChartType = 'bar';
    public barChartColors: Array<any> = [
        { // dark grey
            backgroundColor: 'rgba(128,178,104,1)',
            borderColor: 'rgba(128,178,104,1)',
            pointBackgroundColor: 'rgba(175,125,4,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(175,125,4,1)'
        }];

    public barChartData: any[] = [{ data: [] }];

    public pieChartOptions: ChartConfiguration['options'] = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: { legend: { position: 'bottom' } },
        layout: {
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            }
        }
    };

//    public pieChartPlugins = [DatalabelsPlugin];
    public pieChartData: any[] = [{ data: [] }];
    public pieChartType: ChartType = 'pie';
    public pieChartLabels: any[] = ["Uppfyllda standarder", "Ej uppfyllda standarder"];

    constructor(
        private alertService: AlertService,
        private translationService: AppTranslationService,
        private route: ActivatedRoute,
        private reportService: ReportService,
        private sanitizer: DomSanitizer
    ) {

        this.id = Number.parseInt(this.route.snapshot.paramMap.get('id'));
    }

    ngOnInit() {
        this.reportService.getReportForPrinting(this.id).subscribe(
            reqs => this.onDataLoadSuccessful(reqs),
            error => this.onDataLoadFailed(error));
    }

    private onDataLoadSuccessful(report: ReportPrintViewModel) {
        this.reportSummary = report;

        // Bar chart for aspects
        this.barChartLabels = report.aspectGroups.map(t => t.name + " - " + t.scoreLevelName + (t.scorePercentage == null ? "" : " (" + t.scorePercentage + "%)"));;
        this.barChartData = [{ data: report.aspectGroups.map(t => t.scorePercentage) }];

        // Pie chart for standards

        this.pieChartData = [
            {
                data: [report.report.standardFulfilledPercentage, 100 - report.report.standardFulfilledPercentage],
                backgroundColor: ['rgb(128,178,108)', 'rgb(165,61,48)']
            }
        ];
    }

    private onDataLoadFailed(error: any) {

        this.alertService.showStickyMessage(this.translationService.getTranslation("Error"),
            this.translationService.getTranslation("FetchErrorMessage") +
            "\r\n" +
            Utilities.getHttpResponseMessage(error),
            MessageSeverity.error,
            error);
    }

    public getThreashold(scores: ScoreLevelInfo[], index: number): string {
        if (scores[index].scoreLevel > 0) {
            return scores[index].name + " från " + scores[index].threashold + "%";
        } else {
            return scores[index].name + " mindre än " + scores[index + 1].threashold + "%";
        }
    }

    public getHtml(text?: string): any {
        if (text == null) {
            return "";
        }

        let textParsed = text.replace(/(?:\r\n|\r|\n)/g, '<br />');

        return this.sanitizer.sanitize(SecurityContext.HTML, textParsed);
    }

    public getPreviousStandardGroupFulfillmentPercentage(report?: ReportPrintViewModel, standardGroupId?: number): any {
        const a = report.previousReportStandardGroups.find(t => t.standardGroupId === standardGroupId);
        return (a ? "<strong>" +  a.fulfilledPercentage + "%</strong>" : "");
    }

    public getYear(date?: Date): string {
        if (date) {
            if (typeof(date) === "string") {
                const dt = new Date(date);
                return dt.getFullYear().toString();
            } else {
                return date.getFullYear().toString();
            }
        }
        return "";
    }

    public getStandardLabel(standardFulfillment: number): string {
        switch (standardFulfillment) {
            case 1:
                return "Uppfylld";
            case 0:
                return "Ej uppfylld";
            default:
                return "";
        }
    }
}
